import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import Pusher from 'pusher-js';

import * as actItemHub from 'actions/businessLibrary/item';
import { PUSHER_APP_KEY } from 'api/constants';

import NoDataAndLoading from 'components/NoDataAndLoading';
import { PageWrapper, ContentWrapper } from 'components/wrappers/pages';

import ItemDetail from './ItemDetail';
import ActionBar from './ActionBar/ActionBar';
import List from './List/List';

class Item extends Component {
  componentDidMount() {
    const { dispatch, businessId } = this.props;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    this.channel = pusher.subscribe(`moka-${businessId}`);
    dispatch(actItemHub.pageRequest());
  }

  componentWillUnmount() {
    this.props.dispatch(reset('itemHub'));
    this.props.dispatch(actItemHub.setToggleWriteMode(false));
    if (this.channel) {
      this.channel.unbind();
    }
  }

  componentDidUpdate() {
    const { dispatch, eventAsyncJob } = this.props;
    if (this.channel) {
      this.channel.unbind();
    }
    if (eventAsyncJob.channelName !== null) {
      this.channel.bind(eventAsyncJob.channelName, data => {
        if (data.job_id && data.success) {
          dispatch(actItemHub.pageRequest());
        } else if (data.job_id && !data.success) {
          dispatch(actItemHub.handleErrorAsyncJob(data.error));
        }
      });
    }
  }

  render() {
    const {
      itemMeta,
      isWriteMode,
      loadingSpinner: { showLoadingSpinnerPage },
    } = this.props;
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <NoDataAndLoading
            showLoadingSpinner={showLoadingSpinnerPage}
            noDataToDisplay={itemMeta.total_items === 0 && !isWriteMode}
            title="No Data To Display"
            description=""
            linkLabel="Create Item Manually"
            linkUrl="https://mokaposhelp.zendesk.com/hc/id/articles/900000454306-Cara-Membuat-Barang"
          />
          {!showLoadingSpinnerPage && !isWriteMode && <List />}
          {!showLoadingSpinnerPage && isWriteMode && <ItemDetail />}
        </ContentWrapper>
      </PageWrapper>
    );
  }
}

const mapStateToProps = state => {
  const { loadingSpinner } = state;
  const {
    itemMeta,
    isWriteMode,
    eventAsyncJob,
  } = state.businessLibrary.itemHub;

  return {
    eventAsyncJob,
    loadingSpinner,
    itemMeta,
    isWriteMode,
    businessId: state.moka.user.business.id,
  };
};

const connected = connect(mapStateToProps)(Item);

export default connected;
